<template>
  <div class="upload-overlay-container">
    <LoadingBox
      :is-loading="isLoading"
      size="sm"
    />

    <div
      v-if="!isLoading"
      class="content-placeholder"
    >
      <span class="text">Mudar foto</span>

      <input
        type="file"
        accept="image/x-png, image/gif, image/jpeg"
        @change="handleFileUpload"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import LoadingBox from '@/components/layout/LoadingBox'

  export default {
    components: {
      LoadingBox,
    },

    data: () => ({
      isLoading: false,
    }),

    methods: {
      ...mapActions('user', ['updateUserAvatar']),

      async handleFileUpload ($event) {
        this.isLoading = true

        const file = $event.target.files[0]
        
        const response = await this.updateUserAvatar(file)
        if (!response.success) {
          this.$emit('error', response.error)
        } else {
          this.$emit('success')
        }

        this.isLoading = false
      }
    }
  }
</script>

<style scoped lang="scss">
  .upload-overlay-container,
  .content-placeholder,
  input[type=file] {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .upload-overlay-container {
    z-index: 10;

    .content-placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: rgba(#000, .75);
      transition: .5s all;
      opacity: 0;

      .text {
        font-family: 'Poppins';
        color: #fff;
        font-weight: 600;
        font-size: 13px;
      }

      input[type=file] { opacity: 0; cursor: pointer }
    }

    &:hover .content-placeholder {
      opacity: 1;
    }
  }
</style>